import { AppDispatch, AppThunk } from '../../definitions/types';
import getConfig from '../../config';
import reload from '../../modules/reload';
import { invalidUserIdToken } from '../../redux/actions/errors';
import {
  setLoadingCTA,
  setLoadingPage,
  setToSAcceptanceStatus,
  setUserHasBusiness,
} from '../../redux/actions/options';
import { AppState } from '../../redux/reducers';
import {
  AcceptanceApi,
  Configuration,
} from '@jimdo/terms-and-conditions-service-openapi-typescript-fetch-client';
import { getUserAccountIdFromCookie } from '../../modules/cookies';
import { trackError } from '../../modules/tracking';

enum TermsNames {
  ONESTOP = 'ONESTOP',
}

interface CmsBackendWebsiteResponseFromPublicApi {
  id: string;
  name: string | null;
  business_entity?: string;
}

export const grw1410ExperimentId = 'experiment-grw-1410-onestop-product-picker';

export const fetchUserHasBusiness = (): AppThunk => {
  return async (dispatch: AppDispatch) => {
    dispatch(setLoadingPage(true));
    const userAccountId = getUserAccountIdFromCookie();

    if (userAccountId === '') {
      dispatch(setUserHasBusiness(false));
      return;
    }

    try {
      const response = await fetch(
        `https://register.${
          getConfig().jimdoDomain
        }/api/websites?additional_fields=business_entity&limit=100`
      );
      const json = await response.json();
      const projects: CmsBackendWebsiteResponseFromPublicApi[] = json.results;
      let userHasBusiness = false;
      for (let p of projects) {
        if (p.business_entity !== null) {
          userHasBusiness = true;
          break;
        }
      }
      dispatch(setUserHasBusiness(userHasBusiness));
      dispatch(setLoadingPage(false));
    } catch (e) {
      trackError((e as Error).toString());
      dispatch(setLoadingPage(false));
    }
  };
};

export const acceptOnestopToSAndForward = (): AppThunk => {
  return async (dispatch: AppDispatch, getState: () => AppState) => {
    dispatch(setLoadingCTA(true));
    const userAccountId = getUserAccountIdFromCookie();
    const tosAcceptanceStatus = getState().options.onestopToSAccepted;

    if (userAccountId === '') {
      dispatch(setLoadingCTA(false));
      dispatch(invalidUserIdToken());
      setTimeout(reload);
      return;
    }

    if (!tosAcceptanceStatus) {
      const response = await new TermsAndConditionsAcceptanceClient().acceptOneStopTerms(
        userAccountId
      );
      if (!response) {
        dispatch(setLoadingCTA(false));
        return;
      }
    }

    dispatch(setLoadingCTA(false));
    window.location.href = `${getConfig().dashEndpoint}/?founder=true`;
  };
};

export const fetchOnestopToSAcceptanceStatus = (): AppThunk => {
  return async (dispatch: AppDispatch) => {
    const userAccountId = getUserAccountIdFromCookie();

    if (userAccountId === '') {
      dispatch(setToSAcceptanceStatus(false));
      return;
    }

    const response = await new TermsAndConditionsAcceptanceClient().checkOneStopTerms(
      userAccountId
    );
    dispatch(setToSAcceptanceStatus(response));
  };
};

export class TermsAndConditionsAcceptanceClient {
  readonly client: AcceptanceApi;
  public constructor() {
    this.client = new AcceptanceApi(
      new Configuration({
        basePath: `https://register.${getConfig().jimdoDomain}`,
        headers: {
          'User-Agent': `jimdo-one-stop/1.0 (app:the-sign-up-flow; component:api; env:${
            getConfig().jimdoEnvironment
          }; +https://jimdo.com)`,
        },
      })
    );
  }

  public async acceptOneStopTerms(userId: string): Promise<boolean> {
    try {
      await this.client.acceptTerms({
        userId,
        termsName: TermsNames.ONESTOP,
        acceptTermsRequest: {},
      });
      return true;
    } catch (e) {
      trackError((e as Error).toString());
      return false;
    }
  }

  public async checkOneStopTerms(userId: string): Promise<boolean> {
    try {
      await this.client.getLatestTermsAcceptanceForUser({
        userId,
        termsName: TermsNames.ONESTOP,
      });
      return true;
    } catch (e) {
      trackError((e as Error).toString());
      return false;
    }
  }
}
